module.exports = __webpack_public_path__ + "static/media/champion.9d1455f5.mp3";